import { useTeamscaleInfo } from 'ts/base/hooks/TeamscaleInfoHook';
import type { EFeatureToggle } from 'typedefs/EFeatureToggle';

/** Check if the given feature toggle is used in the project. */
export function useFeatureToggle(featureToggle: EFeatureToggle): boolean {
	const teamscaleInfo = useTeamscaleInfo();
	return teamscaleInfo.enabledFeatureToggles.includes(featureToggle.name);
}
